'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import l from "../defs/CaretDown.js";
var i = Object.defineProperty, n = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var a = (o, e, r) => e in o ? i(o, e, { enumerable: true, configurable: true, writable: true, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    s.call(e, r) && a(o, r, e[r]);
  if (t)
    for (var r of t(e))
      c.call(e, r) && a(o, r, e[r]);
  return o;
}, f = (o, e) => n(o, p(e));
const D = forwardRef((o, e) => /* @__PURE__ */ a__default.createElement(b, f(m({ ref: e }, o), { weights: l })));
D.displayName = "CaretDown";
export {
  D as CaretDown
};
